import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetNotificationsService = (page: number, limit: number) => {
  return HTTP_CLIENT.get(Endpoint.notifications.getNotifications, {
    params: {
      page,
      limit,
    },
  });
};

const GetNotificationCountService = () => {
  return HTTP_CLIENT.get(Endpoint.notifications.getCount);
};

const ReadNotificationService = (notificationId: number) => {
  return HTTP_CLIENT.patch(
    Endpoint.notifications.readNotification.replace(
      ":notification_id",
      notificationId.toString(),
    ),
    {
      notification_id: notificationId,
    },
  );
};

const MarkAllNotificationsReadService = () => {
  return HTTP_CLIENT.patch(Endpoint.notifications.markAllRead);
};

const GetProjectChatUnreadService = (projectId: number) => {
  return HTTP_CLIENT.get(
    Endpoint.notifications.projectChatUnread.replace(
      ":project_id",
      projectId.toString(),
    ),
  );
};

const GetProjectsWithUnreadChatService = () => {
  return HTTP_CLIENT.get(Endpoint.notifications.projectsWithUnreadChat);
};

const MarkProjectChatReadService = (projectId: number) => {
  return HTTP_CLIENT.patch(
    Endpoint.notifications.projectChatRead.replace(
      ":project_id",
      projectId.toString(),
    ),
  );
};

export {
  GetNotificationsService,
  GetNotificationCountService,
  MarkAllNotificationsReadService,
  ReadNotificationService,
  GetProjectChatUnreadService,
  GetProjectsWithUnreadChatService,
  MarkProjectChatReadService,
};
